import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ReactGA from 'react-ga';

import LoadingComponent from '../../../core/LoadingComponent/LoadingComponent';

import './downloadSdk.scss';

class DownloadSdkComponent extends React.Component {
    componentWillMount() {
        const { isLoading, getLatestSdk } = this.props;

        if (!isLoading) {
            getLatestSdk();
        }
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Download SDK Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { title, content, sdk, isLoading } = this.props;

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className="Download-sdk-component">
            <h2>{title}</h2>
            <p>{content}</p>
            <a href={sdk.downloadUrl} target="_self">
                <Button>Download Now</Button>
            </a>
        </div>;
    }
}

DownloadSdkComponent.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    getLatestSdk: PropTypes.func.isRequired,
    sdk: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default DownloadSdkComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/DownloadSdk/DownloadSdkComponent.js